import React, { useCallback } from "react";
import { StringParam, useQueryParams, withDefault } from "use-query-params";
import { useScope } from "@state/scopeContext.lib";
import { useConvertMutation } from "@api/flatRateBilling.api";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { useEffectOnce } from "@hooks/useEffectOnce";
import { useBillingStatus } from "@hooks/useBillingStatus";
import { PageCoverLoader } from "@design-system/PageCoverLoader/PageCoverLoader";

export const Convert: React.FC = () => {
    const { activeWorkspaceKey } = useScope();
    const navigate = useStateAwareNavigate();
    const [{ after: afterCheckoutUrl, code, intent: intentId }] =
        useQueryParams({
            after: StringParam,
            code: withDefault(StringParam, undefined),
            intent: withDefault(StringParam, undefined),
        });

    const { query } = useBillingStatus();
    const afterCheckout = useCallback(async () => {
        await query.refetch();
        navigate(afterCheckoutUrl ?? "/settings/billing");
    }, [afterCheckoutUrl, navigate, query]);

    const convertMutation = useConvertMutation(
        activeWorkspaceKey,
        afterCheckout,
    );

    useEffectOnce(() => {
        convertMutation.mutate({
            code,
            intentId,
        });
    });

    return <PageCoverLoader>Starting autopilot</PageCoverLoader>;
};
